// Mirrors EmailSurveyQuestion in telegramquickchat/models.py.
export const EMAIL_SURVEY_QUESTIONS = ['need_more_help', 'need_human_assistance'] as const;

export type EmailSurveyQuestion = (typeof EMAIL_SURVEY_QUESTIONS)[number];
